/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'More': {
    width: 20,
    height: 6,
    viewBox: '0 0 20 6',
    data: '<path pid="0" d="M20 2.501a2.5 2.5 0 11-5.001.001 2.5 2.5 0 015.001 0zm-7.5 0a2.5 2.5 0 11-5.001.001 2.5 2.5 0 015.001 0zm-7.5 0a2.5 2.5 0 11-5.001.001 2.5 2.5 0 015.001 0z" _fill="#243143" fill-opacity=".6"/>'
  }
})
